module.exports = __webpack_public_path__ + "img/icon_sport_type_29.1dc6c1cc.png";